var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkinline = function SvgLinkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    d: "M10.153 7.912c-.155-.465-.743-1.394-1.859-1.394-1.115 0-4.8 3.717-6.504 5.576-.31.464-.651 1.672.464 2.787 1.394 1.394 3.715.465 5.11-.929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    d: "M8.083 10.568c.161.463.761 1.385 1.876 1.37 1.115-.013 4.755-3.776 6.435-5.655.304-.469.63-1.681-.5-2.782-1.41-1.377-3.72-.418-5.096.993"
  })));
};
export default SvgLinkinline;